import React from 'react'
import { HeaderPageSpacer } from '../../Header/HeaderPageSpacer'
import style from './style.module.scss'

// Deliberately free of react-markdown and MUI: App.js imports this file eagerly for the
// route fallback, so anything imported here lands in the main bundle.

// The hero band with placeholder bars instead of wording. Sized between the retirement and
// medical heroes at each breakpoint (their copy differs in length), so the list below moves
// as little as possible when the real text arrives. The hero's text is per audience
// and comes from the CMS, so until it arrives there is no correct headline to show: the
// built-in retirement default would greet a physician with the wrong seminar.
export const SeminarHeroSkeleton = () => (
  <div className={style.hero} aria-hidden="true">
    <div className={style.heroInner}>
      <div className={`${style.bar} ${style.dark} ${style.kicker}`} />
      <div className={`${style.bar} ${style.dark} ${style.heading}`} />
      <div className={`${style.bar} ${style.dark} ${style.heading}`} />
      <div className={`${style.bar} ${style.dark} ${style.heading} ${style.phoneOnly}`} />
      <div className={`${style.bar} ${style.dark} ${style.heading} ${style.phoneOnly}`} />
      <div className={`${style.bar} ${style.dark} ${style.headingShort}`} />
      <div className={`${style.bar} ${style.dark} ${style.intro}`} />
      <div className={`${style.bar} ${style.dark} ${style.intro} ${style.phoneOnly}`} />
      <div className={`${style.bar} ${style.dark} ${style.intro} ${style.phoneOnly}`} />
      <div className={`${style.bar} ${style.dark} ${style.introShort}`} />
    </div>
  </div>
)

export const SeminarLoading = () => (
  <div className={style.list} role="status" aria-busy="true">
    <span className={style.srOnly}>Loading seminars</span>
    <div aria-hidden="true">
      <div className={`${style.bar} ${style.title}`} />
      <div className={`${style.bar} ${style.subtitle}`} />
      <div className={`${style.bar} ${style.card}`} />
      <div className={`${style.bar} ${style.card}`} />
    </div>
  </div>
)

// The whole /events page, shown while the page's own code is still downloading.
export const EventsPageSkeleton = () => (
  <div className={style.page}>
    <HeaderPageSpacer />
    <SeminarHeroSkeleton />
    <SeminarLoading />
  </div>
)
